/**
 * Thin client for numberlink_gm session APIs (Option B).
 */
import { ARCADE, API_PATH_PROXY_ENABLED } from '../../../utils/config';
import { acquireGmLease, endGmSession, noteGmState } from '../gmLease';

/** Lease key for this game's shared GM (game_engines/gm_registry.py). */
export const GM_GAME_ID = 'numberlink';

export const NUMBERLINK_GM_BASE = API_PATH_PROXY_ENABLED
    ? (ARCADE.numberlink?.API_BASE || '')
    : '/numberlink';

async function parseJson(res) {
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(data.error || `Numberlink GM HTTP ${res.status}`);
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return noteGmState(GM_GAME_ID, data);
}

export async function createNumberlinkSession() {
    await acquireGmLease(GM_GAME_ID);
    const res = await fetch(`${NUMBERLINK_GM_BASE}/session/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: '{}',
    });
    return parseJson(res);
}

export async function moveNumberlinkSession(sessionId, payload = {}) {
    const res = await fetch(`${NUMBERLINK_GM_BASE}/session/${sessionId}/move`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });
    return parseJson(res);
}

export async function deleteNumberlinkSession(sessionId) {
    if (!sessionId) return;
    endGmSession(GM_GAME_ID, sessionId);
    try {
        await fetch(`${NUMBERLINK_GM_BASE}/session/${sessionId}/delete`, { method: 'POST' });
    } catch {
        /* best-effort */
    }
}

export const SEGMENT_POINTS = 35;
export const PAIR_BONUS = 150;
export const SOLVE_BONUS = 300;

export const computeNumberlinkScore = (paths, completedPairs, isSolved) => {
    const segments = Object.values(paths || {}).reduce((sum, path) => sum + (path?.length || 0), 0);
    const completedSize = completedPairs instanceof Set
        ? completedPairs.size
        : (Array.isArray(completedPairs) ? completedPairs.length : (completedPairs?.size || 0));
    let score = segments * SEGMENT_POINTS + completedSize * PAIR_BONUS;
    if (isSolved) score += SOLVE_BONUS;
    return score;
};
